import React from 'react';

function Button({ 
  onClick, 
  disabled, 
  children, 
  type = 'button', 
  style = {},
  variant = 'primary', // primary, secondary, danger, success, outline
  size = 'md' // sm, md, lg
}) {
  // Define button styles based on variant
  const variantStyles = {
    primary: {
      backgroundColor: '#4361ee',
      color: 'white',
      border: 'none'
    },
    secondary: {
      backgroundColor: '#4cc9f0',
      color: 'white',
      border: 'none'
    },
    success: {
      backgroundColor: '#4ade80',
      color: 'white',
      border: 'none'
    },
    danger: {
      backgroundColor: '#f87171',
      color: 'white',
      border: 'none'
    },
    outline: {
      backgroundColor: 'transparent',
      color: '#4361ee',
      border: '1px solid #4361ee'
    }
  };

  // Define button sizes
  const sizeStyles = {
    sm: {
      padding: '6px 12px',
      fontSize: '12px'
    },
    md: {
      padding: '10px 16px',
      fontSize: '14px'
    },
    lg: {
      padding: '14px 24px',
      fontSize: '16px'
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontWeight: '500',
        margin: '4px 0',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        ...variantStyles[variant],
        ...sizeStyles[size],
        ...(disabled ? { 
          backgroundColor: '#ccc', 
          cursor: 'not-allowed',
          opacity: 0.6
        } : {}),
        ...style
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        }
      }}
    >
      {children}
    </button>
  );
}

export default Button;
